<template>
  <router-view />
</template>

<script>
export default {
  // onLaunch: function () {
  //   //console.log("App Launch");
  //   // #ifdef MP
  // },
  // onShow: function () {
  //   //console.log("App Show");
  // },
  // onHide: function () {
  //   //console.log("App Hide"); 
  // },
  // onLoad() {
  //   //console.log("App Load");
  // },

  mounted() {
    // //console.log("App mounted");
    // this.share("App mounted");
  },
  // onReady() {
  //   //console.log("App Ready");
  // },
  watch: {
    $route(newValue, oldValue) {
      var data = {
        title: "中思拓研究院",
        desc: window.location.href,
        img: "https://www.zhongsituo.com/group1/M01/00/17/wKgCGGDiwZGAOIXIAACIMc8UohY7568082?filename=icon.png",
      };
      let msg = this.$shareMsg;
      if (msg[newValue.path]) {
        data.title = msg[newValue.path].title
          ? msg[newValue.path].title
          : data.title;
        data.desc = msg[newValue.path].desc
          ? msg[newValue.path].desc
          : data.desc;
      }
      let acticleDetail = {
        title: '2023中国房地产企业健康评价报告会在京举行',
        desc: '出席报告会的有：中国人民银行、国家数据局相关负责人，国家发改委国际合作中心负责人，我国权威专家，课题组专家代表，主流银行和“资信强企”领导，中思拓研究院负责人等。',
        img: 'https://www.zhongsituo.com/group2/M02/02/4D/wKgCGmWKdKyAdpqKAAFt5zWuV7M4798001?filename=zt_wxshare.jpg'
      }
      if (newValue.path == '/mobile/specialTopic') {//专题页特供
        data = {
          title: acticleDetail.title,
          desc: acticleDetail.desc,
          img: acticleDetail.img,
        }
      }
      // data.title = msg[newValue.path] ? msg[newValue.path].title : data.title;
      // data.desc = msg[newValue.path]
      //   ? msg[newValue.path].desc
      //     ? msg[newValue.path].desc
      //     : ""
      //   : data.desc;
      // console.log("path", newValue.path);
      // console.log("888", data);
      //暂时屏蔽下面
      this.share(data);
    },
  },
  methods: {
    share(data) {
      //H5特有的引入
      // #ifdef  H5
      // let url = location.href.split("#")[0];
      let url = window.location.href;
      //location.href.split('#')[0]
      // url = 'http://m.zhongsituo.cn'
      // //console.log("data", data);
      // //console.log("url", url);
      this.$wechat.share(data, url);
      // #endif
    },
  },
};
//解决android下显示的问题 同样 在app.vue 中也写下面这行自运行函数 写入script 里面即可

(function () {
  if (
    typeof WeixinJSBridge == "object" &&
    typeof WeixinJSBridge.invoke == "function"
  ) {
    handleFontSize();
  } else {
    if (document.addEventListener) {
      document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
    } else if (document.attachEvent) {
      document.attachEvent("WeixinJSBridgeReady", handleFontSize);

      document.attachEvent("onWeixinJSBridgeReady", handleFontSize);
    }
  }

  function handleFontSize() {
    // 设置网页字体为默认大小

    WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 }); // 重写设置网页字体大小的事件

    WeixinJSBridge.on("menu:setfont", function () {
      WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
    });
  }
})();
</script>
<style lang="scss">
body {
  font-family: "Source Han Sans CN, Source Han Sans CN-Regular;" !important;
  -webkit-text-size-adjust: 100% !important;
}

@import "./assets/css/nomalize.scss";
@import "./assets/css/common.scss";
</style>
